import {
  Box,
  Button,
  ButtonAppearance,
  ButtonProps,
  ButtonSize,
  Icon,
  IconStyled,
  TextFieldStyled,
} from '@bechtel/gds';
import { FC } from 'react';
import styled, { css } from 'styled-components';

export const PendingApprovalListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  position: relative;
  overflow-y: auto;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[300]};
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

export const PendingApprovalListHeaderStyled = styled(Box).attrs({
  py: { sm: '400' },
  px: { sm: '500' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const PendingApprovalListBodyStyled = styled(Box).attrs({ flexDirection: { sm: 'column' } })`
  overflow-y: auto;
  height: 100%;
`;

export const TabListStyled = styled(Box).attrs({ mb: { sm: '100' }, flexShrink: { sm: '0' } })`
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 2px 1px -1px rgba(0, 0, 0, 0.12),
    0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;
export interface TabButtonProps extends ButtonProps {
  selected: boolean;
}

export const TabButtonStyled = styled(Button as FC<TabButtonProps>).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.LARGE,
})`
  border: none;
  border-radius: 0;
  position: relative;
  opacity: 0.5;
  &:focus {
    border-color: transparent;
    box-shadow: none;
  }
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.grey[1000]};
    font-size: ${theme.fontSizes['400']};
    padding-bottom: ${theme.spacings[500]};
    padding-top: ${theme.spacings[500]};
    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 5px;
      background-color: ${theme.colors.blue['700']};
      opacity: 0;
    }
  `};
  ${(props) =>
    props.selected &&
    css`
      font-weight: ${props.theme.fontWeights[600]};
      opacity: 1;
      &::after {
        opacity: 1;
      }
    `};
`;

export const PendingApprovalListGroupStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  overflow-y: auto;
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: boolean;
}
export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const SearchIconStyled = styled(Icon)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > svg {
      height: ${({ theme }) => theme.fontSizes[500]};
    }
  }
`;

export const SearchFieldStyled = styled(Box).attrs({
  mr: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
})`
  min-width: 250px; /* Setting min-width to show entire place holder text without cutting off. */
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const PendingApprovalFooterStyled = styled(Box).attrs({
  p: { sm: '500' },
})`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;
